import { forwardRef } from 'react';

import { makeStyles } from '@material-ui/core';

import classNames from 'classnames';

import type { HeaderTabsContainerProps } from './HeaderTabsContainer';
import { NarrowBoxMui } from './NarrowBoxMui';

const useStyles = makeStyles(
  theme => ({
    root: {
      gridArea: 'pageSubheader',
      backgroundColor: theme.palette.background.default,
      paddingBottom: 'var(--encore-spacing-base)',
    },
    narrow: {
      paddingLeft: 'var(--encore-spacing-base)',
      paddingRight: 'var(--encore-spacing-base)',
      '& > div > div': {
        paddingLeft: 0,
      },
    },
    sticky: { position: 'sticky', top: 0, zIndex: 5 },
  }),
  { name: 'HeaderTabsContainer' },
);

/** @deprecated Legacy MUI copy — migrate consumers to the Encore HeaderTabsContainer and delete. */
export const HeaderTabsContainerMui = forwardRef<
  HTMLDivElement | null,
  HeaderTabsContainerProps
>(({ sticky, narrow, children }, ref) => {
  const classes = useStyles();
  return (
    <div
      ref={ref}
      data-component="HeaderTabsContainer"
      className={classNames(classes.root, {
        [classes.narrow]: narrow,
        [classes.sticky]: sticky,
      })}
    >
      {narrow ? (
        <NarrowBoxMui width={typeof narrow === 'string' ? narrow : undefined}>
          {children}
        </NarrowBoxMui>
      ) : (
        children
      )}
    </div>
  );
});
HeaderTabsContainerMui.displayName = 'HeaderTabsContainerMui';
